export default __webpack_public_path__ + "d0a3ca74ab7989533bf6437420492c21.glb";